<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import api from "@/axios";
import { getBaseUrl } from "@/helpers/baseUrl";
import moment from "moment";
import Swal from "sweetalert2";

const STATUS_MAP = {
  CRIADO:      "solicitado",
  PROCESSADO:  "aguardando",
  RASTREANDO:  "em_transito",
};

function mapStatus(item) {
  if (item.statusobj && item.statusobj.toLowerCase().includes("entregue")) return "recebido";
  return STATUS_MAP[item.status] || "encerrado";
}

export default {
  page: {
    title: "Logística Reversa",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Logística Reversa",
      items: [
        { text: "Fretes", href: "/" },
        { text: "Logística Reversa", active: true }
      ],

      filtroBusca: "",
      dtIniFiltro: moment().subtract(7, "days").format("YYYY-MM-DD"),
      dtFimFiltro: moment().format("YYYY-MM-DD"),
      modalDetalhes: null,
      dragCard: null,
      dragFromCol: null,
      carregando: false,

      colunas: [
        { id: "solicitado",   label: "Solicitado",        color: "#6c757d", icon: "bx bx-time-five" },
        { id: "aguardando",  label: "Aguardando Coleta",  color: "#fd7e14", icon: "bx bx-package" },
        { id: "em_transito", label: "Em Trânsito",        color: "#0d6efd", icon: "bx bx-car" },
        { id: "recebido",    label: "Recebido",           color: "#198754", icon: "bx bx-check-circle" },
        { id: "encerrado",   label: "Encerrado",          color: "#6f42c1", icon: "bx bx-lock-alt" }
      ],

      notas: [],
    };
  },

  computed: {
    notasFiltradas() {
      return this.notas.filter(n => {
        if (!this.filtroBusca) return true;
        const busca = this.filtroBusca.toLowerCase();
        return [n.numero_nf, n.cliente, n.codigo_rastreio, n.remetnome]
          .filter(Boolean).join(" ").toLowerCase().includes(busca);
      });
    },

    totalPorColuna() {
      const acc = {};
      this.colunas.forEach(c => { acc[c.id] = { count: 0 }; });
      this.notasFiltradas.forEach(n => {
        if (acc[n._kanbanStatus]) acc[n._kanbanStatus].count++;
      });
      return acc;
    },

    resumo() {
      return {
        total:      this.notasFiltradas.length,
        solicitado: this.notasFiltradas.filter(n => n._kanbanStatus === "solicitado").length,
        aguardando: this.notasFiltradas.filter(n => n._kanbanStatus === "aguardando").length,
        transito:   this.notasFiltradas.filter(n => n._kanbanStatus === "em_transito").length,
      };
    }
  },

  mounted() {
    this.atualizaDataList();
  },

  methods: {
    atualizaDataList() {
      this.carregando = true;
      api.get(`${getBaseUrl()}api/corlogrevs`, {
        params: {
          di: this.dtIniFiltro,
          df: this.dtFimFiltro,
        }
      }).then(response => {
        const lista = response.data[0] || [];
        this.notas = lista.map(item => ({
          id:              item.id,
          numero_nf:       item.codigo || `ID-${item.origem_id}`,
          cliente:         item.destnome || "-",
          remetnome:       item.remetnome || "-",
          codigo_rastreio: item.codobj || "",
          codserv:         item.codserv || "",
          statusobj:       item.statusobj || "",
          data_solicitacao: item.created_at ? item.created_at.slice(0, 10) : "",
          status:          item.status,
          _kanbanStatus:   mapStatus(item),
        }));
      }).finally(() => {
        this.carregando = false;
      });
    },

    notasDaColuna(colunaId) {
      return this.notasFiltradas.filter(n => n._kanbanStatus === colunaId);
    },

    formatData(d) {
      if (!d) return "-";
      const [y, m, dd] = d.split("-");
      return `${dd}/${m}/${y}`;
    },

    abrirDetalhes(nota) {
      this.modalDetalhes = nota;
    },

    fecharDetalhes() {
      this.modalDetalhes = null;
    },

    onDragStart(nota, colunaId) {
      this.dragCard = nota;
      this.dragFromCol = colunaId;
    },

    onDrop(colunaId) {
      if (this.dragCard && this.dragCard._kanbanStatus !== colunaId) {
        this.dragCard._kanbanStatus = colunaId;
      }
      this.dragCard = null;
      this.dragFromCol = null;
    },

    onDragOver(e) {
      e.preventDefault();
    },

    corColuna(id) {
      return this.colunas.find(c => c.id === id)?.color || "#6c757d";
    },

    labelColuna(id) {
      return this.colunas.find(c => c.id === id)?.label || id;
    },

    limparFiltros() {
      this.filtroBusca = "";
      this.dtIniFiltro = moment().subtract(7, "days").format("YYYY-MM-DD");
      this.dtFimFiltro = moment().format("YYYY-MM-DD");
      this.atualizaDataList();
    },

    cancelarLogRev(nota) {
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelar Logística Reversa",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          const prevStatus = nota._kanbanStatus;
          nota._kanbanStatus = "encerrado";
          this.fecharDetalhes();
          api.post(`${getBaseUrl()}api/corlogrevcanc`, {
            iddata: nota.id
          }).then(() => {
            nota.status = "CAN";
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Solicitação cancelada com sucesso",
              showConfirmButton: false,
              timer: 1500
            });
          }).catch(() => {
            nota._kanbanStatus = prevStatus;
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Erro ao cancelar",
              text: "Não foi possível cancelar a solicitação.",
              showConfirmButton: false,
              timer: 3000
            });
          });
        }
      });
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <!-- Cards de resumo -->
    <div class="row mb-3">
      <div class="col-6 col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-muted fw-medium mb-1">Total de Devoluções</p>
                <h4 class="mb-0">{{ resumo.total }}</h4>
              </div>
              <div class="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon ms-3">
                <span class="avatar-title rounded-circle bg-primary">
                  <i class="bx bx-rotate-left font-size-24"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-muted fw-medium mb-1">Solicitados</p>
                <h4 class="mb-0">{{ resumo.solicitado }}</h4>
              </div>
              <div class="avatar-sm rounded-circle align-self-center mini-stat-icon ms-3">
                <span class="avatar-title rounded-circle bg-secondary">
                  <i class="bx bx-time-five font-size-24"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-muted fw-medium mb-1">Aguardando Coleta</p>
                <h4 class="mb-0">{{ resumo.aguardando }}</h4>
              </div>
              <div class="avatar-sm rounded-circle align-self-center mini-stat-icon ms-3">
                <span class="avatar-title rounded-circle bg-warning">
                  <i class="bx bx-package font-size-24"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-muted fw-medium mb-1">Em Trânsito</p>
                <h4 class="mb-0">{{ resumo.transito }}</h4>
              </div>
              <div class="avatar-sm rounded-circle align-self-center mini-stat-icon ms-3">
                <span class="avatar-title rounded-circle bg-primary">
                  <i class="bx bx-car font-size-24"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filtros -->
    <div class="card mb-3">
      <div class="card-body py-2">
        <div class="row g-2 align-items-end">
          <div class="col-md-4">
            <label class="form-label mb-1 small">Busca (NF / Destinatário / Rastreio)</label>
            <input
              v-model="filtroBusca"
              type="text"
              class="form-control form-control-sm"
              placeholder="Digite para filtrar..."
            />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small">De</label>
            <input v-model="dtIniFiltro" type="date" class="form-control form-control-sm" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small">Até</label>
            <input v-model="dtFimFiltro" type="date" class="form-control form-control-sm" />
          </div>
          <div class="col-md-2">
            <button class="btn btn-sm btn-primary w-100" @click="atualizaDataList">
              <i class="bx bx-search me-1"></i>Buscar
            </button>
          </div>
          <div class="col-md-2">
            <button class="btn btn-sm btn-outline-secondary w-100" @click="limparFiltros">
              <i class="bx bx-x me-1"></i>Limpar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="carregando" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
    </div>

    <!-- Kanban Board -->
    <div v-if="!carregando" class="kanban-board-wrapper">
      <div class="kanban-board d-flex gap-3 pb-3" style="overflow-x:auto; min-height:600px;">
        <div
          v-for="col in colunas"
          :key="col.id"
          class="kanban-column flex-shrink-0"
          style="width:260px;"
          @dragover="onDragOver"
          @drop="onDrop(col.id)"
        >
          <!-- Cabeçalho da coluna -->
          <div class="kanban-col-header card mb-2" :style="{ borderTop: '3px solid ' + col.color }">
            <div class="card-body py-2 px-3 d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center gap-2">
                <i :class="col.icon" :style="{ color: col.color, fontSize: '18px' }"></i>
                <span class="fw-semibold" style="font-size:13px;">{{ col.label }}</span>
              </div>
              <span class="badge rounded-pill" :style="{ backgroundColor: col.color }">
                {{ totalPorColuna[col.id].count }}
              </span>
            </div>
          </div>

          <!-- Cards das notas -->
          <div class="kanban-col-body" style="min-height:400px;">
            <div
              v-for="nota in notasDaColuna(col.id)"
              :key="nota.id"
              class="kanban-card card mb-2 shadow-sm"
              draggable="true"
              @dragstart="onDragStart(nota, col.id)"
              style="cursor:grab; border-left: 3px solid transparent;"
              :style="{ borderLeftColor: col.color }"
            >
              <div class="card-body p-2">
                <!-- Topo do card -->
                <div class="d-flex justify-content-between align-items-start mb-1">
                  <span class="fw-bold text-primary" style="font-size:12px;">{{ nota.numero_nf }}</span>
                  <span v-if="nota.codserv" class="badge bg-secondary" style="font-size:10px;">{{ nota.codserv }}</span>
                </div>

                <!-- Destinatário -->
                <p class="mb-1" style="font-size:12px; font-weight:500; line-height:1.3;">
                  <i class="bx bx-building-house text-muted me-1"></i>{{ nota.cliente }}
                </p>

                <!-- Remetente -->
                <p class="mb-1 text-muted" style="font-size:11px; line-height:1.3;">
                  <i class="bx bx-user me-1"></i>{{ nota.remetnome }}
                </p>

                <!-- Status obj -->
                <p v-if="nota.statusobj" class="mb-1 text-muted" style="font-size:11px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;" :title="nota.statusobj">
                  <i class="bx bx-info-circle me-1"></i>{{ nota.statusobj }}
                </p>

                <hr class="my-1" style="border-color:#eee;" />

                <!-- Código de rastreio -->
                <div v-if="nota.codigo_rastreio" class="d-flex align-items-center mb-1">
                  <i class="bx bx-barcode text-muted me-1" style="font-size:12px;"></i>
                  <span class="text-muted" style="font-size:10px; font-family:monospace;">{{ nota.codigo_rastreio }}</span>
                </div>

                <!-- Data -->
                <div class="d-flex justify-content-between mb-2">
                  <span style="font-size:10px;" class="text-muted">
                    <i class="bx bx-calendar me-1"></i>{{ formatData(nota.data_solicitacao) }}
                  </span>
                </div>

                <!-- Ação -->
                <div class="d-flex gap-1">
                  <button
                    class="btn btn-xs btn-outline-secondary flex-grow-1"
                    style="font-size:11px; padding:2px 6px;"
                    @click="abrirDetalhes(nota)"
                  >
                    <i class="bx bx-show me-1"></i>Detalhes
                  </button>
                </div>
              </div>
            </div>

            <!-- Placeholder drop area -->
            <div
              v-if="notasDaColuna(col.id).length === 0"
              class="text-center text-muted py-4"
              style="border: 2px dashed #dee2e6; border-radius: 8px; font-size:12px;"
            >
              <i class="bx bx-inbox font-size-24 d-block mb-1"></i>
              Sem notas nesta etapa
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detalhes -->
    <div v-if="modalDetalhes" class="modal-overlay" @click.self="fecharDetalhes">
      <div class="modal-box card" style="width:480px; max-width:95vw; max-height:88vh; overflow-y:auto;">
        <div class="card-header d-flex align-items-center justify-content-between py-2">
          <h6 class="mb-0">
            <i class="bx bx-file me-2 text-primary"></i>
            {{ modalDetalhes.numero_nf }} — Detalhes
          </h6>
          <button class="btn btn-sm btn-outline-secondary" @click="fecharDetalhes">
            <i class="bx bx-x"></i>
          </button>
        </div>
        <div class="card-body">
          <div class="row g-2">
            <div class="col-6">
              <small class="text-muted d-block">Destinatário</small>
              <strong style="font-size:13px;">{{ modalDetalhes.cliente }}</strong>
            </div>
            <div class="col-6">
              <small class="text-muted d-block">Remetente</small>
              <strong style="font-size:13px;">{{ modalDetalhes.remetnome }}</strong>
            </div>
            <div class="col-6">
              <small class="text-muted d-block">Serviço</small>
              <span style="font-size:13px;">{{ modalDetalhes.codserv || "-" }}</span>
            </div>
            <div class="col-6">
              <small class="text-muted d-block">Status</small>
              <span class="badge" :style="{ backgroundColor: corColuna(modalDetalhes._kanbanStatus) }">
                {{ labelColuna(modalDetalhes._kanbanStatus) }}
              </span>
            </div>
            <div class="col-6">
              <small class="text-muted d-block">Cód. Objeto</small>
              <span style="font-size:13px; font-family:monospace;">{{ modalDetalhes.codigo_rastreio || "-" }}</span>
            </div>
            <div class="col-6">
              <small class="text-muted d-block">Solicitação</small>
              <span style="font-size:13px;">{{ formatData(modalDetalhes.data_solicitacao) }}</span>
            </div>
            <div v-if="modalDetalhes.statusobj" class="col-12">
              <small class="text-muted d-block">Descrição do Status</small>
              <span style="font-size:13px;">{{ modalDetalhes.statusobj }}</span>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center py-2">
          <button
            v-if="['solicitado', 'aguardando', 'em_transito'].includes(modalDetalhes._kanbanStatus)"
            class="btn btn-sm btn-outline-danger"
            @click="cancelarLogRev(modalDetalhes)"
          >
            <i class="bx bx-block me-1"></i>Cancelar Solicitação
          </button>
          <div v-else></div>
          <button class="btn btn-sm btn-outline-secondary" @click="fecharDetalhes">Fechar</button>
        </div>
      </div>
    </div>

  </Layout>
</template>

<style scoped>
.kanban-board {
  align-items: flex-start;
}

.kanban-card {
  transition: box-shadow 0.15s, transform 0.1s;
}
.kanban-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.12) !important;
  transform: translateY(-1px);
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-box {
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  border-radius: 10px;
}

.mini-stats-wid .card-body {
  padding: 1rem;
}

.btn-xs {
  border-radius: 4px;
}
</style>
